const { h, render, Component } = require('preact');
const { Portal } = require('preact-portal');
const PreChatPopUpView = require('./boldchat/prechat');
const { route } = require('preact-router')
const ConfirmationPopup = require('../confirmation_popup/confirmation_popup')

class ChatView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      thankyou: false,
      confirmationPopup: false
    }
    this.liveChatContainer = null;
    this.setLiveChatContRef = this.setLiveChatContRef.bind(this);
    this.open = this.open.bind(this);
    this.handleClick = this.handleClick.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.addEventHandler = this.addEventHandler.bind(this)
    this.handleCloseConfirmationPopup = this.handleCloseConfirmationPopup.bind(this);
    this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
    this.handleCloseButtonClick = this.handleCloseButtonClick.bind(this);
    this.updateChannelSwitchState = this.updateChannelSwitchState.bind(this);
    this.resetChat = this.resetChat.bind(this);
  }

  setLiveChatContRef(element) { 
    this.liveChatContainer = element 
  };

  addEventHandler() {
    var startChatContainer = document.getElementById('thank-you-indicator')
    if (startChatContainer != null) {
      this.setState({open: false})
    if(!this.state.type || (this.state.type=='email' && document.getElementsByClassName('popup')[0]==undefined) || (this.state.type=='callback' && document.getElementsByClassName('click-to-call-popup')[0]==undefined))
      route(`/customer_support/web/thank_you?channel=chat`)
    }
  }



  handleCloseConfirmationPopup() {
    this.setState({
      confirmationPopup: false,
      open: false
    })
  }

  handleBackButtonClick() {
    this.setState({
      open: false, confirmationPopup: false
    });
    let layeredChat = document.getElementById("bc-layered-chat");
    if(layeredChat)
      layeredChat.className = layeredChat.className.replace('hide-chat','');
  }

  handleCloseButtonClick() {
    this.setState({
      open: false, confirmationPopup: false
    });
    var endChat = document.getElementById('bc-end-chat')
    endChat.dispatchEvent(new CustomEvent('click',{detail : {type: 'channel-switch'}}))
    setTimeout(function(){
      let endChat = document.getElementsByClassName('end-chat')[0]
      if(endChat)
        endChat.dispatchEvent(new Event('click'))
    }, 1000)
    var channelsContainer = document.getElementsByClassName('all-channels')[0]
    channelsContainer.dispatchEvent(new CustomEvent('show-popup',{detail : {type: this.state.type}}));
  }

  getTranslationObject(){
    var translationObject = {}
    translationObject.closeText = I18n.translate('js.modules.web_2018.close_text_form')
    translationObject.selectingText = I18n.translate('js.modules.web_2018.selecting_text_chat')
    translationObject.sureText = I18n.translate('js.modules.web_2018.sure_text_chat')
    translationObject.backButtonText = I18n.translate('js.modules.web_2018.back_button_chat')
    translationObject.closeButtonText = I18n.translate('js.modules.web_2018.close_button_chat')
    return translationObject;
  }

  open() {
    this.setState({
      open: true
    });
  }


  handleClose() {
    this.setState({
      open: false
    });
  }

  updateChannelSwitchState(event){
    if(document.getElementById("bc-layered-chat") || document.getElementById("bc-minimized-indicator"))
    {
      this.setState({
        open: false, confirmationPopup: true
      });
      let layeredChat = document.getElementById("bc-layered-chat");
      layeredChat.className = layeredChat.className + ' hide-chat'
    }
    else
    {
      var channelsContainer = document.getElementsByClassName('all-channels')[0]
      channelsContainer.dispatchEvent(new CustomEvent('show-popup', {detail: {type: event.detail.type}}));
    }
    this.setState({type: event.detail.type})
  }

  resetChat(){
    this.setState({
      open: false, confirmationPopup: false
    });
  }

  componentDidMount() {
    var thankYouContainer = document.getElementById("thank-you-container-indicator")
    if (thankYouContainer)
      thankYouContainer.addEventListener('DOMSubtreeModified', this.addEventHandler)
    if (this.liveChatContainer)
      this.liveChatContainer.addEventListener('click', this.handleClick);
    var channelsContainer = document.getElementsByClassName('all-channels')[0]
    if(channelsContainer)
    {
      channelsContainer.addEventListener('channel-switch', this.updateChannelSwitchState, false);
      channelsContainer.addEventListener('no-operator', this.resetChat, false);
    }
  }

  componentWillUnmount() {
    var thankYouContainer = document.getElementById("thank-you-container-indicator")
    if (thankYouContainer)
      thankYouContainer.removeEventListener('DOMSubtreeModified', this.addEventHandler)
    if (this.liveChatContainer) this.liveChatContainer.removeEventListener('click', this.handleClick)
  }

  getLiveChatContainerWithWindowOpen(element) {
    return (element.classList.contains('chat-element') || element.getAttribute('id') == 'live-chat-container'
      || element.closest("#live-chat-container").length > 0) && window.bcChatOpen
  }

  handleClick() {
    var element = document.getElementById('live-chat-container')
    if (this.getLiveChatContainerWithWindowOpen(element)) {
      document.getElementById('bc-minimized-indicator').dispatchEvent(new Event('click'))
      return true
    }
    else if (element.getAttribute('id') == 'live-chat-container' || element.classList.contains('chat-element')) {
      this.open()
      var clickContainer = document.getElementById('live-chat-container').getElementsByClassName('bcStatic')[0].getElementsByTagName("a")[0]
      clickContainer.dispatchEvent(new Event('click'))
      return true
    }
  }

  render() {
    if (this.props.params) {
      let chatConfig = this.props.params.contactChannels.chat;
      if (chatConfig) {
        return (
          <div class='chat-channel-container' id='chat-channel-container'>
            <table ref={this.setLiveChatContRef} class={!chatConfig.isAvailable ? 'channel-grid chat-button channel-unavailable' : 'channel-grid chat-button'} id={chatConfig.id} data-bhw={chatConfig.bhw}>
              <tr class="chat-element" id="web-2018-chat">
                <td class="channel-icon-section chat-element">
                  <span class={!chatConfig.isAvailable ? "icon-bubble-closed channel-icon chat-element channel-unavailable" : 'icon-bubble-closed channel-icon chat-element'}></span>
                </td>
                <td class="channel-text-section chat-element">
                  <span class={!chatConfig.isAvailable ? "channel-text chat-element channel-unavailable" : 'channel-text chat-element'}>{chatConfig.channelText}</span>
                  <span class={!chatConfig.isAvailable ? "recommended chat-element channel-unavailable" : 'recommended chat-element'}> {I18n.translate('js.modules.web_2018.recommended')}</span> <br></br>
                  <span class="channel-msg chat-unavailable channel-unavailable">{chatConfig.channelMsg}</span>
                  <span class="channel-msg chat-available chat-element">{chatConfig.chatAvailableMsg}</span>
                </td>
              </tr>
            </table>
            {this.state.open ? (
              <Portal into="body">
                <div class="prechat-popup" id="web-2018-prechat">
                  <PreChatPopUpView handleClose={this.handleClose} />
                </div>
                <div class="shadow" id="prechat-shadow"></div>
              </Portal>
            ) : null
            }
            {this.state.confirmationPopup ? (
              <Portal into="body">
                <div class="popup">
                  <ConfirmationPopup handleCloseConfirmationPopup={this.handleCloseConfirmationPopup} handleBackButtonClick={this.handleBackButtonClick}
                    handleCloseButtonClick={this.handleCloseButtonClick} translationObject={this.getTranslationObject()} />
                </div>
                <div class="shadow"></div>
              </Portal>
            ) : null
            }
          </div>
        )
      }
      else {
        return null
      }
    }
  }
}

module.exports = ChatView
